<template>
  <div
    class="navbar-container d-flex content align-items-center"
    style="background-color:rgba(255, 255, 255, 0.8);"
  >

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <div>
        <b-link
          to="/"
        >
          <b-img
            style="height: 60px; padding-right: 5px;"
            src="@/assets/images/logo/iconnew.png"
          />
        </b-link>
      </div>
      <!-- <dark-toggler class="d-none d-lg-block" /> -->
      <div>
        <b-link
          to="/"
        >
          <b-img
            style="height: 60px; padding-right: 5px;"
          />
        </b-link>
      </div>
      <div>
        <b-link
          to="/"
        >
          <b-navbar-nav class="nav">
            <b-button
              pill
              variant="flat-primary"
              style="padding-bottom: 8px;"
            >
              <!-- <b-img
                style="height: 19px"
              /> -->
              <label
                style="padding: 5px; font-size: 15px; color: #000000;"
              >
                DASHBOARD
              </label>
            </b-button>
          </b-navbar-nav>
        </b-link>
      </div>

      <div>
        <b-link
          to="building"
        >
          <b-navbar-nav class="nav">
            <b-button
              pill
              variant="flat-primary"
              style="padding-bottom: 8px;"
            >

              <label
                style="padding: 5px; font-size: 15px; color: #000000;"
              >
                BUILDING
              </label>
            </b-button>
          </b-navbar-nav>
        </b-link>
      </div>

      <div>
        <b-link
          to="device"
        >
          <b-navbar-nav class="nav">
            <b-button
              pill
              variant="flat-primary"
              style="padding-bottom: 8px;"
            >

              <label
                style="padding: 5px; font-size: 15px; color: #000000;"
              >
                DEVICE
              </label>
            </b-button>
          </b-navbar-nav>
        </b-link>
      </div>

      <div>
        <b-link
          to="history"
        >
          <b-navbar-nav class="nav">
            <b-button
              pill
              variant="flat-primary"
              style="padding-bottom: 8px;"
            >

              <label
                style="padding: 5px; font-size: 15px; color: #000000;"
              >
                HISTORY
              </label>
            </b-button>
          </b-navbar-nav>
        </b-link>
      </div>
    </div>

    <b-navbar-nav
      v-if="mobile != 1"
      class="nav align-items-center ml-auto"
    >
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ userData.firstname }} {{ userData.lastname }}
            </p>
            <span class="user-status">{{ userData.role }}</span>
          </div>
          <b-avatar
            v-if="mobile != 1"
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/user.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <b-dropdown-item
          v-if="userData.role === 'Admin'"
          link-class="d-flex align-items-center"
          to="user"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Manage User</span>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout()"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BAvatar, BButton, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
// import DarkToggler from '@/@core/layouts/components/app-navbar/components/DarkToggler.vue'

export default {
  components: {
    BButton,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
    BImg,
    // DarkToggler,

    // Navbar Components
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      mobile: '',
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      axios
        .get('/get-info')
        .then(response => {
          this.mobile = response.data[0].debug
          console.log(response.data[0].debug)
        })
    },
    logout() {
      this.$store
        .dispatch('auth/logout')
        .then(() => this.$router.push('/login'))
        .catch(err => console.log(err))
    },
  },
}
</script>
